export {
  Typography,
  type TypographyProps,
  type TypographyVariant,
  type ITypographyProps,
} from './typography';
